<template>
  <div>
    <b-modal
      :title="acao == 'alterar' ? 'Alterar Planejamento' : 'Novo Planejamento'"
      id="modal-resumo"
      no-close-on-backdrop
      no-close-on-esc
      no-fade
      size="lg"
      @show="onShow"
    >
      <b-form-row>
        <b-col v-show="acao == 'alterar'">
          <b-form-group label="Valor Atual Planejado" label-size="sm" label-for="vl_planejado_atual">
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_planejado_atual"
              disabled
              v-model="vl_atual"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="acao == 'incluir'">
          <b-form-group label="Mês/Ano" label-size="sm" label-for="mes_ano">
            <date-picker
              input-class="form-control form-control-sm"
              :clearable="false"
              maxlength="7"
              type="month"
              format="MM/YYYY"
              value-type="format"
              id="mes_ano"
              v-model="registro.mes_ano"
              @change="doChangeDate"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            :label="acao == 'alterar' ? 'Novo Valor Planejado' : 'Valor Planejado da Medição'"
            label-size="sm"
            label-for="vl_planejado"
          >
            <b-form-input
              size="sm"
              maxlength="20"
              id="vl_planejado"
              v-model="registro.vl_planejado"
              trim
              v-mask="{
                alias: 'numeric',
                autoUnmask: true,
                greedy: true,
                radixPoint: ',',
                groupSeparator: '.',
                digits: 2,
                digitsOptional: false,
                autoGroup: true,
                allowPlus: false,
                allowMinus: false,
                onUnMask: function(maskedValue) {
                  var x = maskedValue.split(',');
                  return x[0].replace(/\./g, '') + '.' + x[1];
                },
              }"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="acao == 'alterar'">
          <b-form-group label="Diferença" label-size="sm" label-for="diferenca">
            <b-form-input
              size="sm"
              disabled
              maxlength="20"
              id="diferenca"
              class="text-right"
              v-model="diferencaResumoFormatado"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-show="acao == 'alterar'">
          <b-form-group label="Distribuir a Diferença">
            <b-form-checkbox :value="true" :unchecked-value="false" v-model="ind_distribuir_diferenca"></b-form-checkbox
          ></b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label-size="sm" label="Entidade de Pagto" label-for="ind_entidade_pagto">
            <b-form-select
              size="sm"
              v-model="registro.ind_entidade_pagto"
              :options="[
                { value: 1, text: 'BID' },
                { value: 2, text: 'ESTADO' },
                { value: 3, text: 'BID/ESTADO' },
              ]"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="mt-2">
        <b-col>
          <b-form-group label-size="sm" label="Observações">
            <b-form-textarea
              size="sm"
              no-resize
              v-model="registro.observacoes"
              rows="10"
              maxlength="65535"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="doSaveResumo()" variant="primary"> <i class="fas fa-check"></i> Gravar </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-resumo')">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { baseApiUrl } from "@/global";

import { formatMoney } from "@/global";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  name: "ModalResumo",
  components: { DatePicker },
  computed: {
    diferencaResumoFormatado: {
      get() {
        return formatMoney(parseFloat(this.vl_atual) - parseFloat(this.registro.vl_planejado), 2, "", ".", ",");
      },
    },
  },
  props: {
    registro: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      vl_atual: 0,
      ind_distribuir_diferenca: true,
    };
  },
  methods: {
    doChangeDate(date) {
      this.registro.mes_ano = date;
      this.$forceUpdate();
    },
    doSaveResumo() {
      let _saveObj = {
        programa_id: this.registro.programa_id,
        wbs_id: this.registro.wbs_id,
        resumo_id: this.registro.resumo_id,
        vl_planejado: this.registro.vl_planejado,
        ind_distribuir_diferenca: this.ind_distribuir_diferenca,
        observacoes: this.registro.observacoes,
        ind_entidade_pagto: this.registro.ind_entidade_pagto,
        mes_planejamento: this.registro.mes_ano.split("/")[0],
        ano_planejamento: this.registro.mes_ano.split("/")[1],
        vl_planejado_m2: 0,
        vl_planejado_orig_m2: 0,
        vl_pago: 0,
        vl_pago_m2: 0,
        vl_reconhecido: 0,
        vl_reconhecido_m2: 0,
      };

      if (this.acao == "incluir") {
        axios.post(`${baseApiUrl}/bid/resumo-financeiro`, _saveObj).then(() => {
          this.$emit("updateResumo");
          this.$bvModal.hide("modal-resumo");
        });
      } else {
        axios.put(`${baseApiUrl}/bid/resumo-financeiro`, _saveObj).then(() => {
          this.$emit("updateResumo");
          this.$bvModal.hide("modal-resumo");
        });
      }
    },
    onShow() {
      Vue.nextTick().then(() => {
        this.vl_atual = this.registro.vl_planejado;
        this.registro.mes_ano = this.registro.mes_planejamento + "/" + this.registro.ano_planejamento;
      });
    },
  },
};
</script>

<style></style>
